/**
 * Xero deep-link patterns. Manual journals and AP bills use different paths;
 * every surface in this workspace posts Manual Journals, so the journal URL is
 * the only one needed here.
 */
export const XERO_JOURNAL_URL = 'https://go.xero.com/Journal/View.aspx?invoiceID=';

export const XERO_DASHBOARD_URL = 'https://go.xero.com/app/dashboard';
